import { TopicflowIcon } from "@components/topicflow-icon/topicflow-icon";

import Tooltip from "./tooltip";

const WarningTooltip = ({
  text,
  size = "4",
}: {
  text: string;
  size?: number | string;
}) => (
  <Tooltip text={text}>
    <span>
      <TopicflowIcon
        type="warning"
        className={`h-${size} w-${size} text-orange-400`}
      />
    </span>
  </Tooltip>
);

export default WarningTooltip;
